// extracted by mini-css-extract-plugin
export default {"content":"styles_content__uMUx8","list":"styles_list__PR5ze"};